<template>
  <div class="router-layout">
    <router-view></router-view>
  </div>
</template>

<style>
.router-layout {
  width: 100%;
  height: 100%;
  padding-bottom: 10px;
}
</style>